import { render, staticRenderFns } from "./DownloadReports.vue?vue&type=template&id=bdee7cc8&scoped=true"
import script from "./DownloadReports.vue?vue&type=script&lang=js"
export * from "./DownloadReports.vue?vue&type=script&lang=js"
import style0 from "./DownloadReports.vue?vue&type=style&index=0&id=bdee7cc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdee7cc8",
  null
  
)

export default component.exports